<template>
  <div class="content">
    <div class="title">产品功能介绍</div>
    <div class="bg firstImg" v-for="(item, index) in imgInfo" :data-index="index">
      <img :src="item.url" alt />
      <p class="text">
        <span class="main">{{ item.main }}</span>
        <span class="sub">{{ item.sub }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgInfo: [
        {
          url: require("@/assets/images/website/1.png"),
          main: "多种教学录制场景",
          sub: "答疑讲解白板录制、课前备课区域录制、课后作业全屏录制",
          height: 710
        },
        {
          url: require("@/assets/images/website/2.png"),
          main: "海量教学素材",
          sub: "150万+题库、5万+课件、3万+课程视频、1万+仿真实验···",
          height: 730
        },
        {
          url: require("@/assets/images/website/3.png"),
          main: "专业知识标签",
          sub: "视频标签智能匹配、标签自动关联题库",
          height: 734
        },
        {
          url: require("@/assets/images/website/4.png"),
          main: "一键分享数据实时",
          sub: "链接分享、二维码分享永久生效，分享数据实时看",
          height: 630
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  margin: 80px auto 50px;
  font-size: 44px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 66px;
}
.bg {
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  .text {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 370px;
    text-align: start;
    .main {
      line-height: 42px;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .sub {
      margin-top: 8px;
      line-height: 28px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  &:last-child {
    margin-bottom: 100px;
  }
  &[data-index="0"],
  &[data-index="2"] {
    .text {
      left: 400px;
      top: 225px;
    }
  }
  &[data-index="1"],
  &[data-index="3"] {
    .text {
      right: 341px;
      top: 245px;
    }
  }
}
img {
  // height: 630px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/website/components/introduce.vue